import TeamStatsLayout from 'layouts/team-stats.layout';
import React from 'react';
import Slider from 'react-slick';
import CsStatsPageOne from './cs-stats-page-one';
import CsStatsPageTwo from './cs-stats-page-two';

const CsTeamStats = () => {
  const Settings = {
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000
  };
  return (
    <TeamStatsLayout>
      <Slider {...Settings}>
        <div>
          <CsStatsPageOne />
        </div>
        <div>
          <CsStatsPageTwo />
        </div>
      </Slider>
    </TeamStatsLayout>
  );
};
export default CsTeamStats;
